import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {RouterController} from "../../../core/components/router/router-controller";
import {ScoresListHeaderModuleState} from "../models/scores-list-header-module.state";
import {ScoresListHeaderModuleController} from "../scores-list-header-module.controller";
import {SCORES_HEADER_MODULE} from "../scores-list-header-module.consts";

export class ScoresListHeaderModuleMobileDateClickHandler extends ActionHandler {
  type = SCORES_HEADER_MODULE.ACTION_HANDLERS.mobileDateChange;
  controller: ScoresListHeaderModuleController;
  state: ScoresListHeaderModuleState;
  routerController: RouterController;

  static injectables = [...ActionHandler.injectables, RouterController, DatetimeUtils];

  constructor(routerController: RouterController, datetimeUtils: DatetimeUtils) {
    super();

    this.routerController = routerController;
    this.datetimeUtils = datetimeUtils;
  }

  async action(params) {
    if (!this.controller.props.onDateChange) {
      const sportName: String = this.state.appState.context.sportType?.nameForURL;
      const linkModel = new this.state.linkType(params.filter, sportName, true);
      const routeModel = this.routerController.findRouteByName(linkModel.name);
      const replace: Boolean = !this.routerController.isFormalRoute(routeModel);

      this.navigationManager.gotoRoute(routeModel, linkModel, replace);
    }

    this.controller.action(SCORES_HEADER_MODULE.ACTION_HANDLERS.dateChange);
  }
}
